module.exports = __webpack_public_path__ + "static/img/placeholderGlobalSearch.338d2d8b.svg";